import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home';
import screensaver from '@/components/screensaver/index.vue';
import discover from '@/components/discover/index.vue';
import details from '@/components/details/index.vue';
import compare from '@/components/compare/index.vue';
import technology from '@/components/our-technology/index.vue';
import cover from '@/components/cover/index.vue';
import biopur from '@/components/biopur/index.vue';
import hive from '@/components/hive/index.vue';
// import Hello from '@/components/Hello'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    { path: '/:product', name: 'screensaver', component: screensaver },
    { path: '/:product/discover', name: 'discover', component: discover },
    { path: '/:product/our-technology', name: 'our-technology', component: technology },
    { path: '/:product/details', component: details },
    { path: '/:product/compare', component: compare },
    { path: '/:product/our-technology/cover', name: 'cover', component: cover },
    { path: '/:product/our-technology/biopur', name: 'biopur', component: biopur },
    { path: '/:product/our-technology/hive', name: 'hive', component: hive }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js